<template>
  <b-nav is-nav-bar>
    <b-nav-item-dropdown right is-nav class="nav justify-content-end mobile-menu" text="jump to">
      <b-dropdown-item v-for="item in anchorsList" :key="item.anchor"><router-link :to="{ path: '#' + item.anchor}">{{item.name}}</router-link></b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
  export default {
    name: 'for-authors-mobile-menu',
    props: ['anchorsList']
  }
</script>

<style lang="scss">
  .mobile-menu{
    .dropdown-menu {
        color: $secondary-color;
        padding: 0px;
      .dropdown-item {
        text-align: left;
        padding: 10px 40px;
        background-color: $light-bg;
        border-bottom: 1px solid $white;
        border-right-width: 0px;
        outline: none;
        .router-link-active{
          text-decoration: underline;
        }
        &.active{
           background-color: $light-bg;
           text-decoration: none;
         }
        a{
          outline: none;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// ForAuthorsPageMobileMenu.vue?42fa09a2